import { Operator } from './operator';

export class Range implements Operator {
	public evaluate(value: number, target: number[]): boolean {
		if (target[0] !== undefined && target[1] !== undefined) {
			return value > target[0] && value < target[1];
		} else {
			throw new Error('Bad range.');
		}
	}
}
